<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 10:38:15
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-08 16:45:53
 * @Description: 月报单价确认
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\monthlyReportUnitRecord.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop" style="width: 380px">
          <div v-for="(item, index) in typelist" :key="index" @click="choose(item.status)">
            <div :class="currenindex == item.status ? 'active' : 'text'">
              {{ item.value }}
            </div>
          </div>
        </div>
        <!-- <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
              <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div>
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
        </el-collapse-transition> -->
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">工程名称</span>
              <el-input v-model="tableParam.engineeringName" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">销售员</span>
              <el-select v-model="tableParam.salespersonId" placeholder="请选择">
                <el-option v-for="(item, index) in salesLeadsStatusList" :key="index" :label="item.saller" :value="item.sallerId"></el-option>
              </el-select>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">财务编码</span>
              <el-input v-model="tableParam.financialCode" style="width: 200px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
            <el-button v-if="ButtonList.findIndex(res=>(res.buttonValue=='SCYB'))!==-1" size="medium" class="bottom_all_three" style="margin-left: 12px" @click="monthRecordType=true">生成月报</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection"></el-table-column>
              <el-table-column align="center" label="财务编码"  min-width="160" prop="financialCode"></el-table-column>
              <el-table-column align="center" label="工程编号"  min-width="160" prop="engineeringCode"></el-table-column>
              <el-table-column align="center" label="工程名称" min-width="230" prop="engineeringName"></el-table-column>
              <el-table-column align="center" label="供应阶段" prop="supplyPhase"></el-table-column>
              <el-table-column align="center" label="销售员" prop="salesperson"></el-table-column>
              <el-table-column align="center" label="确认状态" prop>
                <template slot-scope="scope">
                  <span>{{ mouthReportStatusList | fromatTable(scope.row.mouthReportStatus, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.mouthReportStatus == 0" type="success" :underline="false" @click="toConfirm(scope.row)">去确认</el-link>
                  <el-link v-else type="success" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 生成月报 -->
    <el-dialog v-dialogDrag :visible.sync="monthRecordType" width="650px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">生成月报</span>
      <div class="dialoginfo">
        <el-form ref="reftableParam" :inline="true" :model="monthRecordParam" label-width="110px">
          <el-form-item>
          <span slot="label" style="color: #ff0000">生效月份</span>
          <el-date-picker v-model="monthRecordParam.mouthYear" type="month" value-format="yyyy-MM" placeholder="选择日期时间" style="width: 390px"> </el-date-picker>
        </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all" style="margin-left: 24px" @click="getMonthRecord()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, querySales,saveNewMouth } from "@/api/internetSales/monthlyReportUnitRecord.js";
import { getUserInfo } from "@/utils/auth.js";

export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      salesLeadsStatusList: [],
      monthRecordType:false,
      monthRecordParam:{
        mouthYear:"",
        engCodes:[]
      },
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      pagesType: 0,
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
      ],
      currenindex:1,
      typelist: [
        {
          value: "供应中",
          status: 1,
        },
        {
          value: "供应完成",
          status: 2,
        },
      ],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam,type:1,supplerStatus:1, engineeringName: "", salespersonId: "",financialCode:"", };
    this.init();
    this.gettableData();
    querySales().then(res => {
      if (res.code == 1001) {
        this.salesLeadsStatusList = res.data;
      }
    });
  },

  methods: {
    choose(num) {
      this.currenindex = num;
      this.tableParam.supplerStatus = this.currenindex;
      this.gettableData();
    },
    init() {
      /*重置数据*/
      this.tableParam.engineeringName = "";
      this.tableParam.financialCode = "";
      this.tableParam.salespersonId = "";
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    handleSelectionChange(val){
      this.monthRecordParam.engCodes = val.map(item => {
        return item.engineeringCode;
      });
    },
    getMonthRecord(){
      saveNewMouth(this.monthRecordParam).then(() => {
        this.monthRecordType=false
        this.monthRecordParam={
          mouthYear:"",
          engCodes:[]
        }
      });
    },
    //   去确认
    toConfirm(row) {
      this.$router.push({ name: "monthlyReportList", query: { row: JSON.stringify(row) } });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}
.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}
.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}
.el-input,
.el-select {
  width: 240px;
}
.top_link {
  color: #008000;
}
.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
.el-input,
.el-select {
  width: 227px;
}
.dialoginfo {
  padding: 0;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>
  